import React, { createContext } from 'react';

export const RegisterFormTooltipContext = createContext({
  enabled: false,
  defaultTooltip: '',
});

export const RegisterFormTooltipProvider = ({
  children,
  defaultTooltip = 'Lengkapi data pada field ini.',
  enabled = true,
}) => {
  return (
    <RegisterFormTooltipContext.Provider value={{ enabled, defaultTooltip }}>
      {children}
    </RegisterFormTooltipContext.Provider>
  );
};

